import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/shared";
import { ProjectFormFields } from "@/components/projects/NewProjectDialog";

const pick = (p) => ({
  name: p.name, client_id: p.client_id, project_type: p.project_type, description: p.description || "", project_manager_id: p.project_manager_id || null,
  contacts: (p.contacts || []).map((c) => ({ contact_id: c.id, name: c.name, email: c.email })),
  initiated_by_contact_id: p.initiated_by_contact_id || null,
  fee_amount: p.fee_amount ?? "", project_fee: p.commercial_breakdown?.project_fee ?? (p.commercial_breakdown?.recorded ? "" : p.fee_amount ?? ""), passthrough_amount: p.commercial_breakdown?.passthrough ?? "", fee_currency: p.fee_currency || "INR", fee_type: p.fee_type || "estimated",
  next_action_due: p.next_action_due || "", target_delivery_date: p.target_delivery_date || "", start_date: p.start_date || "",
  lead_source: p.lead_source || "", brought_in_by_id: p.brought_in_by_id || null, source_details: p.source_details || "", conference_id: p.conference_id || null,
});

export const EditProjectDialog = ({ open, onOpenChange, p, people, onPersonAdded, clients, onClientsChanged, types, onTypeAdded, currencies, patch, currentUser }) => {
  const [f, setF] = useState(pick(p));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(pick(p)); }, [open, p]);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v?.target ? v.target.value : v }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await patch({ name: f.name.trim(), client_id: f.client_id, project_type: f.project_type, description: f.description, project_manager_id: f.project_manager_id,
        contacts: f.contacts, initiated_by_contact_id: f.initiated_by_contact_id || null, project_fee: f.project_fee === "" ? null : Number(f.project_fee), passthrough_amount: f.passthrough_amount === "" ? null : Number(f.passthrough_amount), fee_currency: f.fee_currency, fee_type: f.fee_type,
        next_action_due: f.next_action_due || null, target_delivery_date: f.target_delivery_date || null, start_date: f.start_date || null,
        lead_source: f.lead_source || null, brought_in_by_id: f.brought_in_by_id || null, source_details: f.source_details || "", conference_id: f.conference_id || null }, "Project details saved");
      onOpenChange(false);
    } catch { /* toast shown by patch */ } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] flex flex-col p-0" data-testid="edit-project-dialog">
        <DialogHeader className="px-6 pt-6"><DialogTitle>Edit project details</DialogTitle><DialogDescription>Changes to the project manager are recorded in Activity.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="flex flex-col min-h-0 flex-1">
          <div className="space-y-4 px-6 py-4 overflow-y-auto min-h-0 flex-1">
            <ProjectFormFields f={f} setF={setF} clients={clients} onClientsChanged={onClientsChanged} people={people} onPersonAdded={onPersonAdded} types={types} onTypeAdded={onTypeAdded} currencies={currencies} currentUser={currentUser} prefix="ep" isEdit />
            <div className="grid grid-cols-3 gap-4">
              <Field label="Fee is">
                <Select value={f.fee_type} onValueChange={set("fee_type")}>
                  <SelectTrigger data-testid="ep-fee-type-select"><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="estimated">Estimated</SelectItem><SelectItem value="agreed">Agreed</SelectItem></SelectContent>
                </Select>
              </Field>
              <Field label="Start date"><Input data-testid="ep-start-input" type="date" value={f.start_date} onChange={set("start_date")} /></Field>
            </div>
          </div>
          <div className="flex justify-end gap-2 px-6 py-4 border-t border-slate-100 bg-white">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button data-testid="ep-submit-button" type="submit" className="bg-teal-600 hover:bg-teal-700" disabled={busy || !f.client_id || !f.lead_source}>{busy ? "Saving…" : "Save changes"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
